import * as _ from "lodash";
import React, { FC } from "react";
import {
  Datagrid,
  List,
  ReferenceField,
  TextField,
  useTranslate,
} from "react-admin";
import DateTimeField from "../components/DateTimeField";
import AvatarField from "../components/AvatarField";
// import { HomeSlideModelName } from "./Create";
import ListActions from "./ListActions";
import ListFilter from "./ListFilters";

const MajorList: FC<any> = (props) => {
  const translate = useTranslate();
  console.log({ ...props }, "props");

  return (
    <List
      {...props}
      title={translate("resources.posts.page.list")}
      actions={<ListActions />}
      filters={<ListFilter />}>
      <Datagrid optimized rowClick="edit">
        <TextField source="sequenceNo" label="Thứ tự" />
        <AvatarField source="imageUrl" label="Thumb" />
        <TextField source="title" label="Tiêu đề" />
        <TextField source="status" label="Trạng thái" />
        <DateTimeField source="timeStart" label="Thời gian hiển thị" />
        <DateTimeField source="timeEnd" label="Thời gian kết thúc" />
        <TextField source="createdBy" label="Người tạo" />
        <DateTimeField source="createdAt" label="Thời gian tạo" />
      </Datagrid>
    </List>
  );
};

export default MajorList;
